import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const ShowChartPagePageReducer = (state = initialState.ShowChartPage, action) => {
  switch (action.type) {
    case actionTypes.ShowChartPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default ShowChartPagePageReducer;
